// extracted by mini-css-extract-plugin
export default {"modalEntrenamiento":"ModalBSD_modalEntrenamiento__Ljrko","modalContent":"ModalBSD_modalContent__7xQQb"};